// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AddAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { AccountModel, BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

const accountsUrl = "/api/v1/awcaccount/PostCustomer";

export interface AwcAccountModel extends AccountModel {
    billTo: BillToModel;
    shipTo: ShipToModel;
    nonce: string;
}

export async function addAccount(parameter: AddAccountApiParameter): Promise<ServiceResult<AwcAccountModel>> {
    try {
        const accountModel = await post<AwcAccountModel>(`${accountsUrl}`, parameter.account as AwcAccountModel);
        return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}